import { keyframes } from 'styled-components';

export const Wobble = keyframes`
  0%,
  100% {
    -webkit-transform: translateX(0%);
            transform: translateX(0%);
    -webkit-transform-origin: 50% 50%;
            transform-origin: 50% 50%;
  }
  15% {
    -webkit-transform: translateX(-20px) rotate(-6deg);
            transform: translateX(-20px) rotate(-6deg);
  }
  30% {
    -webkit-transform: translateX(10px) rotate(6deg);
            transform: translateX(10px) rotate(6deg);
  }
  45% {
    -webkit-transform: translateX(-10px) rotate(-3.6deg);
            transform: translateX(-10px) rotate(-3.6deg);
  }
  60% {
    -webkit-transform: translateX(6px) rotate(2.4deg);
            transform: translateX(6px) rotate(2.4deg);
  }
  75% {
    -webkit-transform: translateX(-4px) rotate(-1.2deg);
            transform: translateX(-4px) rotate(-1.2deg);
  }
`;
